import { fork, all } from 'redux-saga/effects';
import musicSaga from 'containers/MusicPage/saga';
import headerSaga from 'containers/Header/saga';

export default function* appSaga() {
  yield all([fork(musicSaga), fork(headerSaga)]);
}
